import "./utils/desktopAuthBoot"; // [2026-08-12] 必须第一行：在 store/router 加载前同步恢复桌面登录态
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd, { message } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import "./styles/global.less";
import { patchMessage } from "./utils/messageClose";
import { installStaleChunkGuard } from "./utils/staleChunkGuard";

Vue.use(Antd);
Vue.config.productionTip = false;

// 全局提示框: 距顶部 120px, 停留 3.5s, 最多同时显示 3 条
// 配合 styles/global.less 的现代卡片样式 (左侧色带 + 淡彩底 + 精致阴影)
message.config({ top: "120px", duration: 3.5, maxCount: 3 });

// [message 可关闭 + 去重] 给所有提示 (success/info/warning/error) 加 × 关闭按钮, 同一文本在 duration 窗口内去重.
// Vue.use(Antd) 已把同一个 message 实例挂到 Vue.prototype.$message, 这里 patch 一次两边都生效.
patchMessage(message);
patchMessage(Vue.prototype.$message);

// [2026-10-07] chunk 失效兜底: 发版后旧会话首次打开未访问页面时, 旧 chunk 文件已不存在,
// 导航会静默中止(点菜单没反应); 守卫捕获后弹窗引导用户刷新
installStaleChunkGuard(router);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
